module.exports = __webpack_public_path__ + "img/AW.fc0804df.svg";